<template>
  <div class="Top-top">
    <div class="Top-top-content">
      <div class="Top-top-logo" v-show="logoShow">
        <img v-if="topTwo" src="../../static/webp2/logo@2x.webp" class="logo" />
        <img v-else class="logo" :src="this.imgLogo" />
      </div>
      <div class="Top-top-line"></div>
      <div class="Top-top-text">{{ this.title }}</div>
      <div class="Top-top-login">
        <div v-if="!isLogin">
          <div class="top-login-qiehuan" v-on:click="qiehuan">
            <div class="nologin-icon"></div>
            <div class="nologin-text">切换</div>
          </div>
          <div class="top-login-logout" v-on:click="toLogin">
            <div class="a-icon"></div>
            <div class="text">登录</div>
          </div>
        </div>
        <div v-if="isLogin">
          <div class="top-login-qiehuans" v-on:click="qiehuan">
            <div class="nologin-icon"></div>
            <div class="nologin-text">切换</div>
          </div>
          <div class="top-login-line"></div>
          <div class="top-login-logout">
            <div class="login-icon"></div>
            <div class="login-text">{{ currentUser.name }}</div>
            <div class="login-xiala" @click="personShow()"></div>
            <div
              class="top-login-list"
              v-show="perShow"
              @mouseover="cover()"
              @mouseleave="leave()"
            >
              <div class="list-text" style="margin-top: 3px">个人主页</div>
              <div class="list-text" @click="jump()">后台管理</div>
              <div
                class="list-text"
                @click="loginout()"
                style="margin-bottom: 3px"
              >
                退出
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import casjump from "../common/casjump";
export default {
  data() {
    return {
      isLogin: false,
      loginName: "",
      currentUser: {},
      title: "",
      perShow: false,
      logoShow: false,
      imgLogo: "",
      topTwo: true
    };
  },
  inject: ["reload"],
  mixins: [casjump],
  components: {},
  mounted() {
    this.getPerson();
    if (sessionStorage.getItem("person")) {
      let data = JSON.parse(sessionStorage.getItem("person"));
      this.isLogin = true;
      this.currentUser.name = data;
    }
    this.getLogo();
  },
  methods: {
    qiehuan() {
      sessionStorage.removeItem("cmsInfo");
      sessionStorage.setItem("index", 0);
      this.$router.push("/");
      this.reload();
    },
    toLogin() {
      this.$router.push("/login");
    },
    getPerson() {
      GMS.vbus.$on("logininfo", data => {
        this.isLogin = true;
        this.currentUser = data;
        sessionStorage.setItem("person", JSON.stringify(data.name));
      });
    },
    loginout() {
      if (window.osConfig.ossUrl) {
        GMS.util.nros
          .getPlugin("login")
          .logout()
          .then(res => {
            localStorage.removeItem("TGT");
            sessionStorage.removeItem("person");
            window.location.href = window.location.origin;
          });
      } else {
        var config = {
          method: "get",
          url: `${window.osConfig.baseUrl}/nvwa/logout`,
          headers: {
            Authorization: localStorage.getItem("_token") //设置token 其中K名要和后端协调好
          }
        };
        axios(config)
          .then(function(response) {
            if (response.status == 200) {
              localStorage.removeItem("TGT");
              sessionStorage.removeItem("person");
              window.location.href = window.location.origin;
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    cover() {
      this.perShow = true;
    },
    leave() {
      this.perShow = false;
    },
    personShow() {
      this.perShow = true;
    },
    jump() {
      this.casjump(window.osConfig.staticService);
    },
    getLogo() {
      GMS.$http
        .get("/portal/logo/query")
        .then(res => {
          if (res.status == 200) {
            this.title = res.data.title ? res.data.title : "教育事业部产品门户";
            if (res.data.topTwo) {
              this.imgLogo = res.data.topTwo;
              this.topTwo = false;
            }
          }
          this.logoShow = true;
        })
        .catch(error => {
          this.title = "教育事业部产品门户";
          this.logoShow = true;
          this.$Message.error("获取数据异常，请联系管理员");
        });
    }
  }
};
</script>

<style lang="less" scoped>
.Top-top {
  width: 100%;
  height: 114px;
  .Top-top-content {
    width: 1200px;
  }
  @media screen and (max-width: 1500px) {
    .Top-top-content {
      width: 1200px;
    }
  }
  @media screen and (min-width: 1500px) and (max-width: 1800px) {
    .Top-top-content {
      width: 1400px;
    }
  }
  @media screen and (min-width: 1800px) {
    .Top-top-content {
      width: 1600px;
    }
  }
  .Top-top-content {
    height: 114px;
    margin: 0 auto;
    .Top-top-logo {
      float: left;
      width: 330px;
      height: 45px;
      margin-top: 34px;
      // background: url("../../static/webp2/logo@2x.webp") no-repeat;
      // background-size: 330px 45px;
    }
    .logo {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
    .Top-top-line {
      float: left;
      margin-left: 18px;
      margin-right: 18px;
      width: 2px;
      height: 28px;
      background: #d1d1d1;
      margin-top: 42px;
    }
    .Top-top-text {
      float: left;
      font-weight: 400;
      font-size: 28px;
      color: #fff;
      letter-spacing: 0;
      height: 42px;
      line-height: 42px;
      margin-top: 35px;
    }
    .Top-top-login {
      float: right;
      height: 25px;
      // margin-right: 50px;
      line-height: 25px;
      color: #fff;
      margin-top: 42px;
      .top-login-name {
        font-weight: 400;
        font-size: 18px;
        color: #fff;
        letter-spacing: 0;
        float: left;
      }
      .top-login-line {
        // margin-left: 30px;
        margin-right: 25px;
        float: left;
        width: 1px;
        width: 1px;
        height: 20px;
        background: #d8d8d8;
        margin-top: 2px;
      }
      .top-login-qiehuan {
        margin-right: 50px;
        float: left;
        color: #fff;
        cursor: pointer;
      }
      .top-login-qiehuans {
        margin-right: 24px;
        float: left;
        color: #555555;
        cursor: pointer;
      }
      .top-login-logout {
        position: relative;
        float: left;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
.top-login-list {
  width: 88px;
  background: #ffffff;
  position: absolute;
  top: 23px;
  right: -15px;
  z-index: 5;
  box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}
.a-icon {
  width: 23px;
  height: 23px;
  // margin-top: 3px;
  margin-right: 5px;
  background: url("../../static/img1/默认头像2.png") no-repeat;
  background-size: 23px 23px;
  float: left;
}
.text {
  cursor: pointer;
  float: left;
  // width: 20px;
  height: 20px;
  line-height: 20px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 18px;
  color: #03a9e6;
  letter-spacing: 0.27px;
}
.nologin-icon {
  width: 23px;
  height: 23px;
  // margin-top: 3px;
  margin-right: 5px;
  background: url("../../static/webp2/切换@2x.webp") no-repeat;
  background-size: 23px 23px;
  float: left;
}
.nologin-text {
  float: left;
  // width: 20px;
  height: 20px;
  line-height: 20px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0.27px;
}
.login-icon {
  width: 23px;
  height: 23px;
  // margin-top: 3px;
  margin-right: 5px;
  background: url("../../static/img1/默认头像3.png") no-repeat;
  background-size: 23px 23px;
  float: left;
}
.login-text {
  float: left;
  // width: 20px;
  margin-right: 5px;
  height: 20px;
  line-height: 20px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0.27px;
}
.login-xiala {
  cursor: pointer;
  float: left;
  width: 18px;
  height: 20px;
  margin-top: 2px;
  background: url("../../static/img1/下拉2.png") no-repeat;
  background-size: 20px 18px;
}
.list-text {
  height: 34px;
  line-height: 34px;
  text-align: center;
  color: #424242;
}
.list-text:hover {
  cursor: pointer;
  background: #ebf1f6;
  color: #005791;
}
</style>



// WEBPACK FOOTER //
// src/components/topS.vue